export var containsPixelUnit = function containsPixelUnit(value) {
  return value.substr(-2) === 'px' && !isNaN(+value.slice(0, -2));
};